import React from 'react';
import { motion } from 'framer-motion';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section className="w-full bg-navy-mid px-5 py-12 sm:py-20" data-id="element-32" data-mp="gx6mk1kjg47t">
      <div className="mx-auto max-w-5xl" data-id="element-33" data-mp="vtfm748ccjkr">
        <div className="mx-auto max-w-2xl text-center" data-id="element-34" data-mp="vu7f27ak037c">
          <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-35" data-mp="qtjqrtdpm0gt">
            🎁 4 Professional Bonuses—Included at No Extra Cost
          </h2>
          <p className="mt-3 text-sm text-white/70 sm:text-base" data-id="element-36" data-mp="zuhjvgmm0nkm">
            Get all four when you access the complete system today.
          </p>
        </div>
        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2" data-id="element-37" data-mp="1eiug8epm08fn">
          {bonuses.map((bonus, index) => <motion.article key={bonus.badge} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-gold/35 bg-navy p-6 shadow-sm shadow-black/25 sm:p-7" data-id="element-38" data-mp="19mdv7tdpia6s" data-mpi={index}>
              <div className="flex items-center gap-3" data-id="element-39" data-mp="2l2ycgbuh8l9">
                <span className="rounded-md bg-gold px-2.5 py-1 text-[11px] font-bold tracking-wide text-navy" data-id="element-40" data-mp="2np4cbj37g1d">
                  {bonus.badge}
                </span>
                <span className="text-2xl" aria-hidden="true" data-id="element-41" data-mp="ciqpyxe5lzz7">
                  {bonus.icon}
                </span>
              </div>
              <h3 className="mt-4 text-base font-bold leading-snug text-white sm:text-lg" data-id="element-42" data-mp="gjaoa4agr9mx">
                {bonus.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-white/70" data-id="element-43" data-mp="qbq5v0hulw7a">
                {bonus.description}
              </p>
              <div className="mt-5 flex items-center justify-between gap-3" data-id="element-44" data-mp="vbuoox68b30o">
                <span className="text-sm text-white/55 line-through" data-id="element-45" data-mp="10afqh114pur8">{bonus.value}</span>
                <span className="rounded-full bg-gold px-3 py-1 text-xs font-bold text-navy" data-id="element-46" data-mp="akfp8mzwai8b">
                  INCLUDED TODAY
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}